<template>
    <div class="home-menu">
        <div class="menu-item" @click="clickMenu('/rewards')">
            <div class="icon-reward"><img src="@/assets/icon/ic-menu-reward.webp" alt="" /></div>
            <div class="text-reward"><img src="@/assets/other/img-text-reward.png" alt="" /></div>
            <div class="icon-arrow"><img src="@/assets/icon/ic-menu-arrow.webp" alt="" /></div>
        </div>
        <div class="menu-item" @click="clickMenu('/mission')">
            <div class="icon-mission"><img src="@/assets/icon/ic-menu-mission.webp" alt="" /></div>
            <div class="text-mission"><img src="@/assets/other/img-text-mission.png" alt="" /></div>
            <div class="icon-arrow"><img src="@/assets/icon/ic-menu-arrow.webp" alt="" /></div>
        </div>
    </div>
</template>

<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";

export default {
    name: "Home",
    mixins: [LocaleMixin, AccountMixin],
    components: {

    },
    data: function() {
        return {
           
        };
    },
    created: function() {
    },
    methods: {
        clickMenu: function(menu){
            console.log(menu);
            this.$router.push(menu);
        }
    }
};
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
.home-menu{
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding: {
        left: 20px;
        right: 20px;
        bottom: 200px;
    };
    margin: {
        top: 50px;
    };

    .menu-item{
        height: 92px;
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: space-between;
        padding: 0 16px;
        border-radius: 20px;
        background: linear-gradient(270deg, #F3FAFC 23.8%, #FFF 42.33%, #F3FAFC 62.8%);
        box-shadow: 0px 2.338px 4.676px 0px rgba(0, 0, 0, 0.07);
        position: relative;

        .icon-reward{
            margin: {
                top: -48px;
                left: -34px;
            }
            img{
                width: 140px;
            }
        }
        .icon-mission{
            margin: {
                top: -25px;
                left: -16px;
            }
            img{
                width: 110px;
            }
        }
        .text-reward{
            margin-left: 0px;
            margin-right: auto;
            @media (max-width: 360px) {
                margin-left: -15px;
            }
            img{
                width: 150px; 
                @media (max-width: 360px) {
                    width: 110px;
                }
            }
        }
        .text-mission{
            margin-left: 35px;
            margin-right: auto;
            @media (max-width: 360px) {
                margin-left: 0px;
            }
            @media (min-width: 375px) and (max-width: 375px) {
                margin-left: 25px;
            }
            img{
                width: 100px; 
                @media (max-width: 360px) {
                    width: 80px; 
                }
            }
        }

        .icon-arrow{
            position: absolute;
            @include middle-mobile(){
                right: 12px;
            }
            @media (min-width: 390px) {
                right: 16px;
            }
            img{
                width: 42px;
            }
        }
    }
}
</style>
